import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PermissionsFacade } from './infrastructure/permissions.facade';
import { AccessControlEffects } from './state/access-control.effects';
import { AccessControlFacade } from './state/access-control.facade';
import { featureKey, reducer } from './state/access-control.reducer';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(featureKey, reducer),
        EffectsModule.forFeature([AccessControlEffects])
    ],
    providers: [AccessControlFacade, PermissionsFacade]
})
export class AccessControlDomainModule {}
